import { PromotionNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const PROMOTION_NOT_AVAILABLE_LABELS_FR: PromotionNotAvailablePageLabels = {
    headline: 'Il semble qu’il y ait un problème!',
    copyFirst: 'Nous sommes désolés, cette action est introuvable. Elle est probablement terminée.',
    copySecond: 'Tu trouveras ici toutes les offres actuelles.',
};
